import React from 'react';
import { Helmet } from 'react-helmet';

const SchemeMarkupOrganizationContainer = () => (
    <Helmet
        script={[
            {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'Organization',
                    name: 'Grover Group GmbH',
                    url: 'https://www.grover.com/',
                    logo:
                        'https://res.cloudinary.com/grover/image/upload/v1616608519/transactional-emails/grover_logo_new.svg',
                    sameAs: [
                        'https://www.facebook.com/getgrover',
                        'https://twitter.com/getgrover',
                        'https://www.instagram.com/getgrover/',
                        'https://www.youtube.com/getgrover',
                        'https://www.linkedin.com/company/grover',
                    ],
                }),
            },
        ]}
    />
);

export default SchemeMarkupOrganizationContainer;
